// extracted by mini-css-extract-plugin
export default {"container":"UqaxZ","insideItemModal":"SVUZS","pimple":"MkDzJ","updatedIndicationText":"NUPFy","insideModal":"mbGIG","wired":"_9Q8DD"};